// The bin codes a layout rack describes, without three.js, so pages that only draw (Lagerplatser's
// drawing) need not load it. Shared with the phone's "Gå till" scene.

import type { RackElement } from "../api/client.js";

/** The bin codes a rack describes — the same rule as the server's `binsOf` at publish. */
export function binCodes(r: RackElement, pattern: string): string[] {
  if (!r.aisleCode) return [];
  const out: string[] = [];
  const start = r.bayStart ?? 1;
  for (let bay = start; bay < start + r.bays; bay++) {
    const per = r.overrides[String(bay)]?.compartmentsPerBay ?? r.compartmentsPerBay;
    const levels = r.overrides[String(bay)]?.levels ?? r.levels;
    for (let level = 1; level <= levels; level++) for (let c = 1; c <= per; c++) out.push(pattern.replace("{aisle}", r.aisleCode).replace("{bay}", String(bay)).replace("{level}", String(level)).replace("{compartment}", String(c)));
  }
  return out;
}

